var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnverifiedBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9167 4.0832C19.0833 3.09987 20.9667 3.09987 22.1 4.0832L24.7333 6.3332C25.2333 6.74987 26.1833 7.09987 26.85 7.09987H29.6833C31.45 7.09987 32.9 8.54987 32.9 10.3165V13.1499C32.9 13.8165 33.25 14.7499 33.6667 15.2499L35.9167 17.8832C36.9 19.0499 36.9 20.9332 35.9167 22.0665L33.6667 24.6999C33.25 25.1999 32.9 26.1332 32.9 26.7999V29.6332C32.9 31.3999 31.45 32.8499 29.6833 32.8499H26.85C26.1833 32.8499 25.25 33.1999 24.75 33.6165L22.1167 35.8665C20.95 36.8499 19.0667 36.8499 17.9333 35.8665L15.3 33.6165C14.8 33.1999 13.85 32.8499 13.2 32.8499H10.2833C8.51668 32.8499 7.06667 31.3999 7.06667 29.6332V26.7832C7.06667 26.1332 6.73334 25.1832 6.31667 24.6999L4.06667 22.0499C3.10001 20.8999 3.10001 19.0332 4.06667 17.8832L6.31667 15.2332C6.73334 14.7332 7.06667 13.7999 7.06667 13.1499V10.3332C7.06667 8.56654 8.51668 7.11654 10.2833 7.11654H13.1667C13.8333 7.11654 14.7667 6.76654 15.2667 6.34987L17.9167 4.0832Z",
    fill: "#FEC62C",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.5469V21.5969",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9902 26.666H20.0052",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnverifiedBadge);
export default __webpack_public_path__ + "static/media/unverified-badge.1b3bb0d135da2a41618b2bd8a9da29a2.svg";
export { ForwardRef as ReactComponent };